export { QrCode } from "./qr-code";
export type { QrCodeProps } from "./qr-code";
